import React, { useContext } from 'react';
import { Body1, H2 } from '@xo-union/tk-ui-typography';
import ThemeFilters from '../../components/Filters/ThemeFilters';
import ThemeFiltersVariantContext from '../../helpers/ThemeFiltersContext';

import styles from '../../themePicker.scss';

export const ThemesFilterHeader: React.FC = () => {
  const {
    themeFilters,
    loading: filtersLoading,
    themeFilterOptions,
    setFilters,
    themeFilterOptionsDisplayNamesMap,
  } = useContext(ThemeFiltersVariantContext);

  return (
    <div className={styles.header}>
      <H2>Find Your Design</H2>
      <div className={styles.headerTextContainer}>
        <Body1 className={styles.subHeader}>
          Get started by choosing a look for your wedding website! You can switch to a new design at any time.
        </Body1>
      </div>
      {!filtersLoading ? (
        <ThemeFilters
          colors={themeFilterOptions?.colors}
          styles={themeFilterOptions?.themeStyles.map(style => style.key)}
          seasons={themeFilterOptions?.seasons}
          presetFilterState={themeFilters}
          setFilterCriteria={setFilters}
          themeFilterOptionsDisplayNamesMap={themeFilterOptionsDisplayNamesMap}
        />
      ) : null}
    </div>
  );
};
